export default {
    under4ninSetai: {
        //人数 => 光熱費月額*12

        //単身世帯
        1: 1.17*12,
        //2人世帯
        2: 1.96*12,
        //3人世帯
        3: 2.27*12,
        //4人世帯
        4: 2.37*12,
    },
    over5nin: 0.2*12 //一人増える毎に、この金額を加算
}